import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { NavDropdownButton } from "../common";
import CurrentUser from "../user/CurrentUser";
import { useAuth } from "../auth/Authcontext";
import { checkUserAuthorised } from "../utilities/authorisationcheck";

function SideNavigation(props) {
   
    const [toolsOpen, setToolsOpen] = useState(false);

    const { user } = useAuth();

    const userRoles = user && user.scopes 


    return (
        <div className="d-flex flex-column p-3 bg-dark-navy text-white side-navigation">
            <div className="row">
                <Link to="/" className="d-flex align-items-center mb-3 me-md-auto text-decoration-none">
                    <svg className="bi me-2" width="40" height="32" viewBox="0 0 141 152" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M70.5 134.912C56.4751 134.912 43.025 129.336 33.1104 119.413C23.1957 109.49 17.6291 96.0314 17.636 82.0009C17.636 52.7945 43.1815 37.2811 43.1815 17H4" stroke="white" strokeWidth="33.5294"/>
                        <path d="M70.5 134.912C84.5227 134.912 97.9707 129.336 107.884 119.413C117.797 109.49 123.363 96.0314 123.356 82.0009C123.356 52.7945 97.8143 37.2811 97.8143 17H137" stroke="white" strokeWidth="33.5294"/>
                        <path d="M70.5 134.912C56.4751 134.912 43.025 129.336 33.1104 119.413C23.1957 109.49 17.6291 96.0314 17.636 82.0009C17.636 52.7945 43.1815 37.2811 43.1815 17H4" stroke="#293f85" strokeWidth="16.7647"/>
                        <path d="M70.5 134.912C84.5227 134.912 97.9707 129.336 107.884 119.413C117.797 109.49 123.363 96.0314 123.356 82.0009C123.356 52.7945 97.8143 37.2811 97.8143 17H137" stroke="#293f85" strokeWidth="16.7647"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M70.7795 86.5734L59.2624 99.8712L62.4783 82.5757L44.9009 81.8624L60.428 73.5931L50.0264 59.4058L66.1726 66.3896L70.7795 49.4116L75.3863 66.3896L91.5325 59.4058L81.1309 73.5931L96.6581 81.8624L79.0807 82.5757L82.2965 99.8712L70.7795 86.5734Z" fill="white"/>
                    </svg>
                    <span className="text-white fs-4" href="/">FanStable</span>
                </Link>
            </div>
            <div className="row">
                <ul className="nav nav-pills flex-column">
                    <li className="nav-item">
                        <NavLink to="/home" className="nav-link text-white">
                            <i className="bi bi-house me-2"/>
                            Home
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavDropdownButton strict activePath="/tool/" className="nav-link text-white" onClick={() => setToolsOpen(!toolsOpen)} open={toolsOpen}>
                            <i className="bi bi-tools me-2"/>
                            Tools
                        </NavDropdownButton>
                        <div className={`ms-4 collapse ${toolsOpen ? "show" : ""}`}>
                            <ul className="nav">
                                <li>
                                    <Link to="/tool/reset-score" className="nav-link text-white" >
                                        {/* <i className="bi bi-inbox me-2"/> */}
                                        Reset yearly score
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/tool/manage-advertisement-banner" className="nav-link text-white" >
                                        {/* <i className="bi bi-inbox me-2"/> */}
                                        Manage advertisement banner
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </li>

                    {

                        checkUserAuthorised("canCreateHorse" , userRoles) ? (
                            <li className="nav-item">
                                <NavLink to="/horse" className="nav-link text-white">
                                    <svg className="me-2" width="1rem" height="1rem" viewBox="0 0 46 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.94141 4C4.94141 4.4 4.44141 6.16667 4.44141 7L1.44172 12C1.10839 12.5 0.641721 13.7 1.44172 14.5C2.24172 15.3 3.44172 14.8333 3.94172 14.5L7.44172 11C8.44162 11.5 10.0414 13.8 8.44141 19C7.28067 22.7724 8.5058 25.7203 9.90233 27.5M6.94141 4V1C7.77474 1 9.44141 1.6 9.44141 4C11.6081 4.66667 16.1414 7.8 16.9414 15C18.4414 18 19.9414 18 29.9414 17.5C32.2568 17.3842 33.7775 17.9916 34.725 19M6.94141 4C6.60807 3.16667 5.64141 1.5 4.44141 1.5M33.9414 46.5L35.1914 41M35.1914 41L36.4414 35.5L33.9414 30C34.9582 28.729 36.2305 25.4035 36.0547 22.5M35.1914 41L33.9414 35.5C32.7727 35.1104 30.887 34.0835 29.4414 32.3393M15.4414 42.5V29C19.1208 29.4906 22.2361 29.1288 24.4414 28.5834M15.4414 42.5L12.9414 45M15.4414 42.5L11.9414 30.6875M24.4414 28.5834C25.8323 28.2394 26.8613 27.8223 27.4414 27.5C27.6077 29.4951 28.4132 31.0987 29.4414 32.3393M24.4414 28.5834C25.1081 30.2222 26.0414 34.1 24.4414 36.5L20.9414 42.5M20.9414 42.5V45M20.9414 42.5L27.4414 35.5L29.4414 32.3393M34.725 19C36.6305 18.5 40.6414 18.3 41.4414 21.5C42.4414 25.5 39.9414 27.5 44.4414 34C42.6081 33.8889 38.7414 32.6501 37.9414 28.5834C36.9414 23.5 37.3843 24 36.0547 22.5M34.725 19C35.5859 19.9162 35.9737 21.1634 36.0547 22.5M9.90233 27.5C10.4308 28.1735 10.9838 28.6797 11.4414 29L11.9414 30.6875M9.90233 27.5L4.44141 30V39M4.44141 39L7.44172 40.5M4.44141 39L6.94141 32L11.9414 30.6875" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Horses
                                </NavLink>
                            </li>
                        ) : <></>
                    }

                    {
                        checkUserAuthorised("canCreateShow" , userRoles) ? (
                            <li className="nav-item">
                                <NavLink to="/show" className="nav-link text-white">
                                    <i className="bi bi-trophy me-2"/>
                                    Shows
                                </NavLink>
                            </li>
                        ) : <></>

                    }

{/*                     
                    {
                        checkUserAuthorised("canCreateCompetition" , userRoles) ? (
                            <li className="nav-item">
                                <NavLink to="/competition" className="nav-link text-white">
                                    <i className="bi bi-award me-2"/>
                                    Competitions
                                </NavLink>
                            </li>
                        ) : <></>

                    }
                     */}
                    {
                        checkUserAuthorised("canCreateDiscipline" , userRoles) ? (
                            <li className="nav-item">
                                <NavLink to="/discipline" className="nav-link text-white">
                                    <i className="bi bi-clipboard-check me-2"></i>
                                    Disciplines
                                </NavLink>
                            </li>
                        ) : <></>

                    }

                    {
                        checkUserAuthorised("canUpdateAnyUser" , userRoles) ? (

                            <li className="nav-item">
                                <NavLink to="/user" className="nav-link text-white">
                                    <i className="bi bi-person-badge me-2"/>
                                    Users
                                </NavLink>
                            </li>
                        ) : <></>

                    }


                   

                </ul>
            </div>
            <div className="row mt-auto">
                <CurrentUser/>
            </div>
        </div>
    );
}

export default SideNavigation;